
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-2">
            <img 
              src="https://i.imgur.com/4bJ8aNu.jpeg" 
              alt="Thorn Ford Dental Laboratory" 
              className="h-16 w-auto object-contain mb-4"
            />
            <p className="text-gray-300 mb-4">
              Thorn Ford Dental Laboratory - Excellence in precision dental devices 
              and laboratory equipment. Serving dentistry since 1977, trusted by dental professionals throughout the United States for innovative solutions and exceptional quality.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl w-6 h-6 flex items-center justify-center"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl w-6 h-6 flex items-center justify-center"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl w-6 h-6 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <a 
                  href="https://portal.example.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Clinician Portal
                </a>
              </li>
              <li>
                <a 
                  href="https://readdy.ai/?origin=logo" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Made with Readdy
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-2 text-gray-300">
              <div className="flex items-center">
                <i className="ri-phone-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                <span>(425) 486-2732</span>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                <span>admin@thornford.com</span>
              </div>
              <div className="flex items-start">
                <i className="ri-map-pin-line mr-2 mt-1 w-5 h-5 flex items-center justify-center"></i>
                <span>10107 Woodinville Drive<br />Bothell, WA 98011</span>
              </div>
              <div className="flex items-center">
                <i className="ri-time-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                <span>Mon - Fri: 9:00 AM - 5:00 PM</span>
              </div>
            </div>
          </div>

        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 Thorn Ford Dental Laboratory. All rights reserved. Serving Dentistry Since 1977.</p>
        </div>
      </div>
    </footer>
  );
}
